// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rsReviewListPage .reviewColumn{padding-right:16px}
`, "",{"version":3,"sources":["webpack://./src/pages/reviewListPage/ReviewListPage.scss"],"names":[],"mappings":"AAAA,gCAEE,kBAAmB","sourcesContent":[".rsReviewListPage {\n\t.reviewColumn {\n\t\tpadding-right: 16px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
